import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconVideoPlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.25 10.1238C9.25 8.82786 10.6755 8.03777 11.7745 8.72463L14.6407 10.516C15.7374 11.2014 15.7374 12.7986 14.6407 13.484L11.7745 15.2754C10.6755 15.9622 9.25 15.1722 9.25 13.8762V10.1238ZM10.9795 9.99663C10.8796 9.93419 10.75 10.006 10.75 10.1238V13.8762C10.75 13.994 10.8796 14.0658 10.9795 14.0034L13.8457 12.212C14.0024 12.1141 14.0024 11.8859 13.8457 11.788L10.9795 9.99663Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
		fill: "currentColor"
	})]
});
export { SvgIconVideoPlay as ReactComponent };
